import { routes } from "Projects/config/routes";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PortfolioDetails from "./routes/PortfolioDetails";
import { injectReducer } from "store/reducers";
const {
  portfolios: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
          import(
            /* webpackChunkName: "project-group" */ "./modules/StudentPortfoliosModules"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1;
          injectReducer(store, {
            key: reducer.NAME,
            reducer: reducer.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [PortfolioDetails(store)],
  };
};
